import React, { useEffect, useMemo } from 'react';
import { Container, Sprite } from '@pixi/react';
import { observer } from 'mobx-react-lite';
import { menuSectionStore } from '../../../../store/menuSectionStore';
import { isMobile } from '../../../../core/helpers/isMobile';
import { applicationStore } from '../../../../store/applicationStore';
import { getGameImages } from '../../../../core/helpers/getGameImages';

const InfoSectionBackground = observer(({ x = 0, y = 0 }) => {
  const { isShowPayTableMode } = applicationStore;
  const { isShowMenuPopup, setIsShowMenuPopup } = menuSectionStore;

  const { background, logo } = useMemo(() => {
    return getGameImages();
  }, []);

  useEffect(() => {
    if (!isShowPayTableMode) {
      setIsShowMenuPopup(false);
    }
  }, [setIsShowMenuPopup, isShowPayTableMode]);

  return (
    <Container x={x} y={y} visible={isShowMenuPopup} name='InfoSectionBackground'>
      {isMobile() ? (
        <Container x={270} y={64} name='InfoSectionGameLogo'>
          <Sprite anchor={0.5} texture={logo} />
        </Container>
      ) : (
        <Sprite texture={background} />
      )}
    </Container>
  );
});

export default InfoSectionBackground;
